export enum Partner {
  finizens = 'Finizens',
  caser = 'Caser'
}

